import PersonForm from "@/components/Forms/PersonForm.tsx";
import type { ReactNode } from "react";
import { useParams } from "react-router-dom";

const PersonDetail = (): ReactNode => {
    const { personId } = useParams<{ personId: string }>();

    if (!personId) {
        return <div>No Person ID provided</div>;
    }

    return (
        <div>
            <PersonForm personId={personId} />
        </div>
    );
};

export default PersonDetail;
